import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxPermissionsModule } from 'ngx-permissions';
import { HeaderComponent } from './components/header/header.component';
import { NavigationMobileComponent } from './components/navigation-mobile/navigation-mobile.component';
import { NavigationWebComponent } from './components/navigation-web/navigation-web.component';
import { PaginationComponent } from './components/pagination/pagination.component';

@NgModule({
  declarations: [
    HeaderComponent,
    PaginationComponent,
    NavigationMobileComponent,
    NavigationWebComponent,
  ],
  imports: [CommonModule, FormsModule, RouterModule, NgxPermissionsModule.forChild()],
  exports: [
    HeaderComponent,
    PaginationComponent,
    NavigationMobileComponent,
    NavigationWebComponent,
  ],
})
export class LayoutModule {}
